import dawn from "../assets/phaser-royal-caravans/dawn.webp";
import guild from "../assets/phaser-royal-caravans/guild.webp";
import crown from "../assets/phaser-royal-caravans/crown.webp";
import wheel from "../assets/phaser-royal-caravans/wheel.webp";
import road from "../assets/phaser-royal-caravans/road.webp";
/** Normalized rig coordinates measured after mirroring the generated cutouts. */
export const CARAVAN_ART = { road, wheel, tiers: [
  { body: dawn, ratio: 660 / 836, axleY: .957, axles: [.195, .678], wheel: .195, ru: "Рассвет", en: "Dawn" },
  { body: guild, ratio: 670 / 940, axleY: .96, axles: [.228, .695], wheel: .195, ru: "Гильдия", en: "Guild" },
  { body: crown, ratio: 776 / 930, axleY: .958, axles: [.185, .70], wheel: .195, ru: "Корона", en: "Crown" },
] } as const;
